import React from "react";
import styles from "./home.module.css";
import Hero from "./landing/hero/Hero";
import About from "./landing/about/About";
import Accessible from "./landing/accessible/Accessible";
import Idea from "./landing/idea/Idea";
import Ecosystem from "./landing/ecosystem/Ecosystem";
import Working from "./landing/working/Working";
import Services from "./landing/services/Services";
import Advisor from "./landing/advisor/Advisor";
import Partner from "./landing/partner/partner";
import Security from "./landing/security/Security";
import Team from "./landing/team/Team";
import Servicespoint from "./landing/servicespoint/Servicespoint";

function Home() {
  return (
    <div className={styles.home}>
      <Hero />
      <About />
      <Accessible />
      <Idea />
      <Ecosystem />
      <Servicespoint />
      <Services />
      <Partner />
      <Advisor />
      <Team />
      <Security />
      <Working />
    </div>
  );
}

export default Home;
